import { post, get, postJson, deleteApi, put, deleteApiJson,postUrl } from "../axios";

const RESOURCE_BASE_PATH = "/intelligent-marketing/api/";

export default {
  nodetype: [
    "",
    "vip",
    "merge",
    "extraction",
    "intersection",
    "exclude",
    "unique",
    "msg",
    "analyze",
    "targetGroups",
    "await",
    "order",
    "presell",
    "medium",
    'customer',
    "card",
    "targetGroups",
    "crowd",
    'customer',
    
  ],
  nodetypeText: [
    "会员筛选",
    "订单筛选",
    "指定号码",
    "等待",
    "合并",
    "抽取",
    "交集",
    "排除",
    "排重",
    "短信",
    "营销响应",
    "营销分析",
    "目标人群",
    "人群筛选",
    "订单筛选",
    "预售订单",
    '人群分析'
  ],

  //新增节点
  addNode(p) {
    return postJson(`${RESOURCE_BASE_PATH}addNode`, p);
  },
  //更新节点坐标
  updateCoordinate(p) {
    return put(`${RESOURCE_BASE_PATH}updateCoordinate`, p);
  },
  //更新节点关系
  updateNodeRel(p) {
    return postJson(`${RESOURCE_BASE_PATH}nodeRel/save`, p);
  },
  //删除节点
  delNode(p) {
    return deleteApi(`${RESOURCE_BASE_PATH}delNode`, p);
  },
  //删除节点关系接口
  delNodeRel(p) {
    return postJson(`${RESOURCE_BASE_PATH}nodeRel/del`, p);
  },
  //批量删除节点
  delBatchNode(p) {
    return deleteApiJson(`${RESOURCE_BASE_PATH}batchDel`, p);
  },
  //复制节点
  copyNode(id, p) {
    return postJson(
      `${RESOURCE_BASE_PATH}copyNode?nodeId=${id}&coordinate=${p}`
    );
  },
  // 批量复制节点
  copyBatchNode(p) {
    return postJson(`${RESOURCE_BASE_PATH}batchCopyNode`, p);
  },
  //批量移动
  updateCoordinateBatch(p) {
    return put(`${RESOURCE_BASE_PATH}updateCoordinateBatch`, p);
  },

  //另存为模板
  addTemplate(p) {
    return postJson(`${RESOURCE_BASE_PATH}saveTemplate`, p);
  },
  //获取节点列表
  getNodeList(p) {
    return get(`${RESOURCE_BASE_PATH}getNodeList`, p).then((res) => {
      let nodeDataArray = [];
      let linkDataArray = [];
      let marketingDetail = {};
      let subCount = 0;
      let pcoordinate;
      let half;
      if (res.code === 1) {
        if (res.data.nodeDetail) {
          subCount = res.data.nodeDetail.reduce((count, i) => {
            if (!i.coordinate) {
              if (!pcoordinate) {
                let pid;
                res.data.relation.some((sitem) => {
                  if (sitem.nodeId === i.nodeId) {
                    pid = sitem.parentId;
                    return true;
                  }
                });
                //查找没有位置的节点，他爸
                res.data.nodeDetail.some((titem) => {
                  if (titem.nodeId === pid) {
                    pcoordinate = titem.coordinate.split(",");
                    return true;
                  }
                });
              }
              count++;
              return count;
            } else {
              return count;
            }
          }, 0);
          half = subCount / 2;
          var total = subCount;
          nodeDataArray = res.data.nodeDetail.map((item) => {
            item.key = item.nodeId;
            item.category = this.nodetype[item.type];
            item.text = item.name;
            //没有位置的，参考父元素定位 @author:林建炜
            item.coordinate = item.coordinate
              ? item.coordinate.replace(",", " ")
              : ((xy) => {
                  let t = subCount;
                  if (half > subCount) {
                    //下方元素
                    t = `${parseInt(xy[0]) + 290} ${
                      parseInt(xy[1]) +
                      (half - subCount + (total % 2 ? 1 : 0)) * 120
                    }`;
                  } else {
                    if (half === subCount - 0.5) {
                      //中间的那个
                      t = `${parseInt(xy[0]) + 280} ${parseInt(xy[1])}`;
                    } else {
                      //上方元素
                      t = `${parseInt(xy[0]) + 290} ${
                        parseInt(xy[1]) - (subCount - half) * 120
                      }`;
                    }
                  }
                  subCount--;
                  this.updateCoordinate({
                    nodeId: item.nodeId,
                    coordinate: t.replace(" ", ","),
                  });
                  return t;
                })(pcoordinate);
            item.executionStatus === 3 || item.executionStatus === 4 || item.executionStatus === 0
              ? item.preExecutionCount !== -1 &&
                (item.resultCount =
                  item.preExecutionCount !== undefined
                    ? item.preExecutionCount
                    : "")
              : item.formalExecutionCount !== -1 &&
                (item.resultCount =
                  item.formalExecutionCount !== undefined
                    ? item.formalExecutionCount
                    : "");
                    if(item.resultCount){
                      item.resultCount =  item.resultCount.toLocaleString();
                    }
            return item;
          });
        } else {
          nodeDataArray = [];
        }
        linkDataArray = res.data.relation
          ? res.data.relation.map((item) => {
              return {
                from: item.parentId,
                to: item.nodeId,
                ids: item.id,
                fromPort: "R",
                toPort: "L",
                text:item.text?item.text:'',
                connectionType:item.connectionType
              };
            })
          : [];
        marketingDetail = res.data.status;
      }
      return {
        nodeDataArray: nodeDataArray,
        linkDataArray: linkDataArray,
        marketingDetail: marketingDetail,
      };
    });
  },
  //获取节点的统计号码数
  getExecNodeResultCount(p) {
    return get(`${RESOURCE_BASE_PATH}getExecNodeResultCount`, p);
  },
  //获取节点
  getNode(p) {
    return get(`${RESOURCE_BASE_PATH}getNodeDetail`, p);
  },
  //更新短信节点
  updateSmsDetail(p) {
    return put(`${RESOURCE_BASE_PATH}sms/updateDetail`, p);
  },
  //批量更新短信节点
  batchSmsUpdate(p) {
    return postJson(`${RESOURCE_BASE_PATH}sms/batchUpdate`, p);
  },
  //更新节点明细内容
  updateDetail(p) {
    return put(`${RESOURCE_BASE_PATH}common/updateDetail`, p);
  },
  //更新抽取节点
  updateDetailextract(p) {
    return put(`${RESOURCE_BASE_PATH}extract/updateDetail`, p);
  },
  //更新排除节点
  updateDetailexclude(p) {
    return put(`${RESOURCE_BASE_PATH}exclude/updateDetail`, p);
  },
  //更新排重节点
  updateDetailremoveDup(p) {
    return put(`${RESOURCE_BASE_PATH}removeDup/updateDetail`, p);
  },
  //恢复编辑
  redesignMarketing(id) {
    return postJson(`${RESOURCE_BASE_PATH}redesignMarketing?marketingId=${id}`);
  },
  //测试执行
  testIntelligentMarketing(id) {
    return postJson(
      `${RESOURCE_BASE_PATH}testIntelligentMarketing?marketingId=${id}`
    );
  },
  //正式执行
  execacticity(p) {
    return postJson(`${RESOURCE_BASE_PATH}exec-acticity`, p);
  },
  //获取最终发送人数及短信量接口
  getExecNodeAllResultCount(p) {
    return get(`${RESOURCE_BASE_PATH}getExecNodeAllResultCount`, p);
  },
  //获取最终发送人数及短信量接口
  getsendTime(p) {
    return get(`/sms/official/intelligent/send-time`, p);
  },
  batchUpdate(p) {
    return postJson(`${RESOURCE_BASE_PATH}wait/batchUpdate`, p);
  },
  getStatus(p) {
    return get(`/intelligent-marketing/api/${p}`);
  },
  //查询订单节点人数
  orderCount(p) {
    return postJson(`${RESOURCE_BASE_PATH}order/count`, p);
  },
  //查询预售订单节点人数
  presaleOrderCount(p) {
    return postJson(`${RESOURCE_BASE_PATH}presale/order/count`, p);
  },
  //更新富信短信节点
  updateMediumDetail(p) {
    return put(`${RESOURCE_BASE_PATH}mediaSms/updateDetail`, p);
  },
  //更新卡片短信节点
  updateCardDetail(p) {
    return put(`${RESOURCE_BASE_PATH}cardSms/updateDetail`, p);
  },
  getAutoName(p) {
    return get(`${RESOURCE_BASE_PATH}getAutoNodeName?nodeId=${p}`);
  },
  //排除智能命名
  getAutoName1(p,e) {
      return get(`${RESOURCE_BASE_PATH}getAutoNodeName?nodeId=${p}&sourceNodeId=${e}`);
    },
  //获取人群分析批次
  getExecRecordList(p) {
    return get(`${RESOURCE_BASE_PATH}getExecRecordList?marketingId=${p}`);
  },
  //人群分析查询接口
  crowdAnalys(p) {
    return get(`${RESOURCE_BASE_PATH}crowdAnalys`,p);
  },
  /**
   * 撤销操作
   * @param {formData} p [撤销节点参数集合]
   * @example
   * @author:林建炜
   * quash({
   *    "smartMarketingId": "Number",
   *  })
   * @returns A new Promise response
   */
  quash(p) {
    return postUrl(`${RESOURCE_BASE_PATH}quash`, p);
  },
  recovery(p) {
    return postUrl(`${RESOURCE_BASE_PATH}recovery`, p);
  },
  //人群分析导出
  exportCrow(p) {
    return postJson(`${RESOURCE_BASE_PATH}crowAnalysis/export`, p);
  },
  //插入后置节点
  addPostNode(p){
    return postJson(`${RESOURCE_BASE_PATH}addPostNode`,p);
  },
  intelligentExportDong(p) {
    return get(`/sms/marketing/effect/analyze/official/select/export`,p);
  },
};
